import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class PlgSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "plgId";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }

    override getResourceName(): string {
        return "plg";
    }

    override getResource(): string {
        return "composite-option-group";
    }
}
